/**
 * Reviews slider – Splide.js
 */
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

var reviews = {
    options: {
        slider: '.js-reviewsSlider',
        prevArrow: '.js-reviewsPrev',
        nextArrow: '.js-reviewsNext',
        dot: '.js-reviewsDot',
    },

    init: function () {
        var self = this;

        document.querySelectorAll(self.options.slider).forEach(function (el) {
            self.initSlider(el);
        });
    },

    initSlider: function (el) {
        var self      = this;
        var container = el.closest('.block-reviews');

        var splide = new Splide(el, {
            type        : 'loop',
            perPage     : 1,
            gap         : '46px',
            padding     : { left: '20%', right: '20%' },
            focus       : 'center',
            arrows      : false,
            pagination  : false,
            speed       : 500,
            easing      : 'ease',
            breakpoints : {
                1023: {
                    gap     : '16px',
                    padding : { left: '8%', right: '8%' },
                },
            },
        });

        // Custom arrows
        if (container) {
            var prev = container.querySelector(self.options.prevArrow);
            var next = container.querySelector(self.options.nextArrow);

            if (prev) prev.addEventListener('click', function () { splide.go('<'); });
            if (next) next.addEventListener('click', function () { splide.go('>'); });
        }

        // Custom dots (avatar thumbnails)
        var dots = container ? container.querySelectorAll(self.options.dot) : [];

        splide.on('mounted move', function () {
            var index = splide.index;
            dots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i === index);
            });
        });

        dots.forEach(function (dot, i) {
            dot.addEventListener('click', function () {
                splide.go(i);
            });
        });

        splide.mount();
    },
};

export { reviews };
